import { Typography } from '@carto/meridian-ds/components'
import { FormattedMessage } from 'react-intl'
import { Box, FormControlLabel, Switch } from '@mui/material'
import { useAccountWorkflowSettings, useUpdateAccountWorkflowSettings } from 'features/account/hooks/accountHooks'
import { ACCOUNT_MIN_WIDTH } from 'features/account/constants'
import { theme } from '@carto/meridian-ds/theme'

export function WorkflowsCustomization() {
  const { data, isLoading } = useAccountWorkflowSettings()
  const { mutateAsync, isLoading: isUpdating } = useUpdateAccountWorkflowSettings()

  return (
    <Box sx={{ maxWidth: theme.spacing(ACCOUNT_MIN_WIDTH) }}>
      <Typography variant="subtitle2" color="textSecondary" mb={3}>
        <FormattedMessage id="account.workflows.extensionPackages.title" />
      </Typography>
      <Typography variant="body2" color="textSecondary">
        <FormattedMessage id="account.workflows.extensionPackages.description" />
      </Typography>
      <Box mt={1.5} mb={1.5}>
        <FormControlLabel
          label={<FormattedMessage id="account.workflows.extensionPackages.enabled" />}
          labelPlacement="end"
          value="enabledPackageExtension"
          disabled={isLoading || isUpdating}
          control={
            <Switch
              name="enabledPackageExtension"
              onChange={(e) =>
                mutateAsync({
                  installExtensions: e.target.checked
                })
              }
              checked={data?.installExtensions}
            />
          }
        />
      </Box>
    </Box>
  )
}
